import React from 'react'
import '../styles/Button.css'
import { Link } from 'react-router-dom'

function Button({ children, type, onClick, buttonStyle, buttonSize }) {

    const STYLES = ['btn--primary', 'btn--outline', 'btn--black', 'btn--orange', 'carousel-btn'];
    const SIZES = ['btn--medium', 'btn--large'];

    const checkButtonStyle = STYLES.includes(buttonStyle) ? buttonStyle : STYLES[0]
    const checkButtonSize = SIZES.includes(buttonSize) ? buttonSize : SIZES[0];

    return (
        <Link to='/' className='btn-mobile'>
            <button className={`btn ${checkButtonStyle} ${checkButtonSize}`} onClick={onClick} type={type} >
                {children}
            </button>
        </Link>
    )
}

export default Button